import { LockClosedIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/solid'
import { useAuth } from '../hooks/useAuth'

// Guided screen for 401/403 (and missing-token) situations: tells the operator
// exactly what's wrong and offers a single "Entrar novamente" action that
// re-authenticates. On return, App re-validates the permission before letting in.
function AuthIssuePage() {
  const { accessIssue, relogin, decodeToken, token } = useAuth()

  const payload = decodeToken(token)
  const email = payload?.email || payload?.user?.email || null

  const isPermission = accessIssue === 'permission'
  const title = isPermission ? 'Sem permissão para ativar' : 'Sessão expirada'
  const detail = isPermission
    ? 'Sua conta não tem permissão para ativar baterias. Peça o acesso ao seu gestor e, depois de liberado, entre novamente.'
    : 'Sua sessão não é mais válida. Entre novamente para continuar a ativação.'

  return (
    <div className="min-h-screen bg-[#0d1117] text-white flex flex-col items-center justify-center p-4 font-sans">
      <div className="w-full max-w-md mx-auto text-center">
        <div className="mx-auto mb-6 w-20 h-20 rounded-full bg-yellow-500/10 flex items-center justify-center">
          <LockClosedIcon className="w-11 h-11 text-yellow-400" />
        </div>

        <h1 className="text-2xl font-bold text-gray-100">{title}</h1>
        <p className="mt-3 text-gray-300 leading-relaxed">{detail}</p>

        {email && (
          <p className="mt-4 text-sm text-gray-500">
            Conectado como <span className="font-mono text-gray-300">{email}</span>
          </p>
        )}

        <button
          onClick={relogin}
          className="mt-8 w-full inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-bold py-3 px-6 rounded-md hover:bg-blue-500 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300"
        >
          <ArrowRightOnRectangleIcon className="w-5 h-5" />
          Entrar novamente
        </button>

        {isPermission && (
          <p className="mt-4 text-xs text-gray-500">
            Já pediu o acesso e foi liberado? Toque em <b>Entrar novamente</b> para revalidar.
          </p>
        )}
      </div>
    </div>
  )
}

export default AuthIssuePage
